import { matchPath } from 'react-router';

import { PATH_TITLES, DEFAULT_TITLE } from '../constants/app';

export const getTitleFromPath = (pathname) => {
  if (matchPath(pathname, { path: '/orders', exact: true })) return 'Orders';
  if (matchPath(pathname, { path: '/account', exact: true })) return 'Account';
  if (matchPath(pathname, { path: '/orders/strata', exact: true })) return 'Order Strata Search';
  if (matchPath(pathname, { path: '/orders/council', exact: true })) return 'Order Council Search';
  if (matchPath(pathname, { path: '/orders/form1', exact: true })) return 'Order Form 1';
  if (matchPath(pathname, { path: '/users', exact: true })) return 'Users';
  if (matchPath(pathname, { path: '/orders/:orderId', exact: true })) return 'Order Details';
  if (matchPath(pathname, { path: '/connections', exact: true })) return 'Connections';

  return PATH_TITLES[pathname] || DEFAULT_TITLE;
};

export default getTitleFromPath;